import humps from 'humps'

type ResponseData = {
  data: any
  meta?: any
  links?: any
  included?: any
}

const transformResponse = (response: any) => {
  if (!response) return {}

  const { data, links, meta, included, message } = JSON.parse(response) || {}

  if (message) return message

  let formattedData: any = {}
  let formattedIncluded: any = []

  if (Array.isArray(data)) {
    formattedData = data.map((record: any) => ({
      id: record?.id,
      type: record?.type,
      ...record.attributes,
    }))
  } else {
    formattedData = {
      id: data?.id,
      type: data?.type,
      status: data?.status,
      ...data?.attributes,
    }
  }

  formattedIncluded = included?.map((item: any) => {
    return {
      id: item.id,
      type: item.type,
      ...item.attributes,
    }
  })

  const jsonApiData: ResponseData = {
    data: humps.camelizeKeys(formattedData),
  }

  if (links) {
    jsonApiData['links'] = humps.camelizeKeys(links)
  }

  if (meta) {
    jsonApiData['meta'] = humps.camelizeKeys(meta)
  }

  if (included && included.length > 0) {
    jsonApiData['included'] = humps.camelizeKeys(formattedIncluded)
  }

  return jsonApiData
}

export default transformResponse
